import { inject, Injectable } from '@angular/core';
import { formatDate } from '@angular/common';
import { ENDPOINTS } from '../constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DateService {
    private http = inject(HttpClient);


  transformDate(date: Date): string {
    return formatDate(date, 'YYYY-MM-dd', "en-US") || '';
  }


  getAgeFromDob(dob: string | null): number {
    if (!dob) return 0;

    const birthDate = new Date(dob);
    if (isNaN(birthDate.getTime())) return 0;

    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  getImageUrl(fileName: string) {
    return this.http.get(`${ENDPOINTS.LOOKUP.GET_IMAGE}?fileName=${fileName}`)
  }
}
